import { expVal } from '@atlassian/jira-feature-experiments';
import type { FlagConfiguration } from '@atlassian/jira-flags';
import { KNOWN_ERROR_MESSAGE } from './constants.tsx';
import messages from './messages.tsx';

export const getSaveValueErrorFlag = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	error: any,
	isAdminOrProjectAdmin: boolean,
	onOpenSettings: () => void,
) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const errorMessage = error.errors?.find((e: any) => e.error)?.error;
	const isKnownErrorMessage = errorMessage && errorMessage.includes(KNOWN_ERROR_MESSAGE);
	const FLAG = expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
		? KNOWN_ERROR_NON_ADMIN_FLAG
		: KNOWN_ERROR_NON_ADMIN_FLAG_WITH_ISSUE_TERM;

	if (error.statusCode === 400 && isKnownErrorMessage) {
		return isAdminOrProjectAdmin
			? knownErrorAdminFlagConfig({
					onOpenSettings,
				})
			: FLAG;
	}
	if (error.statusCode) {
		return GENERIC_ERROR_FLAG;
	}
	return NETWORK_ERROR_FLAG;
};

export const KNOWN_ERROR_NON_ADMIN_FLAG_WITH_ISSUE_TERM: FlagConfiguration = {
	type: 'error',
	title: messages.knownErrorNonAdminTitle,
	description: messages.knownErrorNonAdminDescription,
};

export const KNOWN_ERROR_NON_ADMIN_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.knownErrorNonAdminTitle,
	description: messages.knownErrorNonAdminDescriptionIssueTermRefresh,
};

export const knownErrorAdminFlagConfig = ({
	onOpenSettings,
}: {
	onOpenSettings: () => void;
}): FlagConfiguration => ({
	type: 'error',
	title: expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
		? messages.knownErrorAdminTitleIssueTermRefresh
		: messages.knownErrorAdminTitle,
	actions: [{ content: messages.knownErrorAdminCta, onClick: onOpenSettings }],
});

export const GENERIC_ERROR_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.genericErrorTitle,
};

export const NETWORK_ERROR_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.networkErrorTitle,
};
